import { Box, Text } from '@chakra-ui/react'

const DateCard = ({day, id, todayMeetingId}) => {
  if (todayMeetingId === id) {
    return (
      <>
        <Box
          bg='brandTextBlack'
          display='flex'
          alignItems='center'
          justifyContent='center'
          boxSize='55px'
          borderRadius='16px'
        >
          <Text fontSize='32px' color='white' ml={'-1px'} mb={1}>
            {day.date}
          </Text>
        </Box>
        <Text color='brandTextBlack'>{day.day}</Text>
      </>
    )
  }
  return (
    <>
      <Text fontSize='32px' color='brandTextGrey2'>
        {day.date}
      </Text>
      <Text color='brandTextGrey2'>{day.day}</Text>
    </>
  )
  
}

export default DateCard